import { useEffect, useMemo, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import useApi from "../../hooks/useApi";

export default function ModalAtribuirResponsavel({
  onClose,
  equipamentos,
  equipamentoId,
  defaultEquipamentoId,
  onAssigned,
}) {
  const api = useApi();
  const lockedEquipamento = useMemo(() => {
    const id = equipamentoId ?? defaultEquipamentoId ?? "";
    if (!id) return null;
    return (equipamentos ?? []).find((x) => x.id === id) ?? null;
  }, [defaultEquipamentoId, equipamentoId, equipamentos]);

  const equipamentoOptions = useMemo(() => {
    return (equipamentos ?? []).map((e) => `${e.id} | ${e.patrimonio} | ${e.descricao}`);
  }, [equipamentos]);

  const byLabel = useMemo(() => {
    const m = new Map();
    (equipamentos ?? []).forEach((e) => {
      m.set(`${e.id} | ${e.patrimonio} | ${e.descricao}`, e.id);
    });
    return m;
  }, [equipamentos]);

  const defaultLabel = useMemo(() => {
    if (lockedEquipamento) {
      return `${lockedEquipamento.id} | ${lockedEquipamento.patrimonio} | ${lockedEquipamento.descricao}`;
    }
    const e = (equipamentos ?? []).find((x) => x.id === defaultEquipamentoId);
    if (!e) return "";
    return `${e.id} | ${e.patrimonio} | ${e.descricao}`;
  }, [defaultEquipamentoId, equipamentos, lockedEquipamento]);

  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    equipamentoLabel: defaultLabel,
    matricula: "",
  });

  const [ nomeColaborador, setNomeColaborador] = useState("");

  const buscarColaborador = async () => {

    if ( form.matricula.length !== 6 ) {
      return;
    }
    
    try {

      const { data } = await api.post("/Painel/API/GetColabInfo/", {
        matricula: form.matricula
      })

      // Caso o campo STATUS seja igual a 'DESLIGADO' então não atribuir o responsável.
      if ( data[0].STATUS === 'DESLIGADO' ) {
        alert("Colaborador desligado.");
        return;
      }

      setNomeColaborador(data[0].NOME);

    }catch ( error ) {

      console.error(error);
      alert("Erro ao buscar informações do colaborador.");

    }

  }

  useEffect(() => {

    if ( form.matricula.length === 6 ) {

      // Buscar informações do colaborador
      buscarColaborador();
      
    }else{
      setNomeColaborador("");
    }
    
  }, [ form.matricula ])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value.toUpperCase() }));
  };

  const canSubmit = useMemo(() => {
    if (lockedEquipamento) return true;
    return Boolean(form.equipamentoLabel) && Boolean(byLabel.get(form.equipamentoLabel));
  }, [byLabel, form.equipamentoLabel, lockedEquipamento]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSaving(true);
      const resolvedId = lockedEquipamento ? lockedEquipamento.id : byLabel.get(form.equipamentoLabel);
      // Rota fictícia (backend você vai criar)
      await api.post("/Painel/API/InventarioTI/SaveResponsavel/", {
        id_ativo: resolvedId,
        matricula: String(form.matricula || "").trim(),
      });
      onClose?.();
      onAssigned?.();
    } catch (err) {
      console.error(err);
      alert("Erro ao atribuir responsável.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Overlay state={true}>
      <Modal header close={onClose} size="md">
        <Formulario onSubmit={handleSubmit}>
          {lockedEquipamento ? (
            <FormComp
              title="EQUIPAMENTO"
              type="text"
              readOnly
              valor={`${lockedEquipamento.id} | ${lockedEquipamento.patrimonio} | ${lockedEquipamento.descricao}`}
            />
          ) : (
            <FormComp
              title="EQUIPAMENTO"
              type="select"
              options={equipamentoOptions}
              valor={form.equipamentoLabel}
              name="equipamentoLabel"
              changeFunc={handleChange}
              required
            />
          )}
          <FormComp
            title="MATRÍCULA DO RESPONSÁVEL"
            type="text"
            placeholder="EX: 012345"
            valor={form.matricula}
            name="matricula"
            changeFunc={handleChange}
            required
            maxLength={6}
          />
          <FormComp
            title="NOME DO RESPONSÁVEL"
            type="text"
            readOnly
            valor={nomeColaborador}
          />
          <FormComp
            type="submit"
            valor={saving ? "SALVANDO..." : "SALVAR"}
            disabled={saving || !canSubmit}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}